import { enquiry } from "@/utils/constants";
import { handleError, handleResponse } from "@/utils/functions";

export default (axios) => ({
  getGeneratedQuotes(data) {
    return new Promise((resolve, reject) => {
      axios
        .post(enquiry.rateEnquiry, data)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
})
